import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmResultInfoType } from '../interfaces/IKnmResultInfoType';

export async function fetchKnmResultInfoTypes(): Promise<IKnmResultInfoType[]> {
  return apiGet<IKnmResultInfoType[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-result-info-types`,
  );
}
